const itemConstruccion = {
//     "Cajas": {
// 		"type": "item",
// 		"label": "Cajas",
// 		"link": "/coordination",
// 		"icon": "PieChartOutlined",
// 		"iconType": "antd-icon",
// 		"key": 1
// 	},
	"Dashboard": {
		"type": "item",
		"label": "Dashboard",
		"key": 1
	},
	"Proyectos": {
		"type": "item",
		"label": "Proyectos",
		"key": 2
	},
	"Construccion": {
		"type": "parent",
		"label": "Construcción",
		"key": 3
	},
	"Mapa": {
		"type": "item",
		"label": "Mapa",
		"parent": "Construccion",
		"key": 1
	},
	"Ticket": {
		"type": "item",
		"label": "Ticket",
		"parent": "Construccion",
		"key": 2
	}

}

export { itemConstruccion }